import 'antd/lib/col/style';
import 'antd/lib/tooltip/style';
import 'antd/lib/button/style';
import 'antd/lib/icon/style';
import 'antd/lib/select/style';
import 'antd/lib/row/style';

import '../VtxGrid.less';